export class CategoryModel {
  constructor() {
    this.id = null;
    this.title = "";
    this.imageUrl = "";
    this.status = "";
    this.isLock = false;
  }
}
